import { SetFunctionType } from '../types/utils.type'

export const processResult = (
    setFunctions: SetFunctionType,
    toastMessage: string,
    success: boolean
) => {
    const { setIsModalShown, setToastData, setShowToast, setIsLoading } =
        setFunctions
    setIsLoading(false)
    setIsModalShown(false)
    setToastData({
        variant: success ? 'success' : 'critical',
        message: toastMessage,
    })
    setShowToast(true)
}
